export default __webpack_public_path__ + "static/avatar4-638c390be7afa7d1ff9781184fc0e6b6.jpg";